import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ScheduleDate, Parameter, BonusInfo, BonusType } from '@akiba/models_bimbo';
import { MatTable, MatDialog, MatDatepickerInputEvent, MatCheckboxChange, MatSelectChange } from '@angular/material';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import { Moment } from 'moment';

@Component({
  selector: 'app-ps-parameters-contribution',
  templateUrl: './ps-parameters-contribution.component.html',
  styleUrls: ['./ps-parameters-contribution.component.scss']
})
export class PsParametersContributionComponent implements OnInit {
  @Input() modParameter: Parameter;
  @ViewChild('registrationDatesTable', { static: false }) registrationDatesTable: MatTable<ScheduleDate>;
  displayedRegistrationDatesColumns: string[] = ['Tipo', 'Inicio', 'Fin', 'active', 'delete'];
  newRegistrationDate = new ScheduleDate();
  newBonusInfo = new BonusInfo({ userLeve: -1, percentage: 0, type: null });
  newBonusType: BonusType | null = null;
  newBonusName: string = '';
  bonusType = [
    { value: "annualPerformance", name: "Bono Anual Por Desempeño" },
    { value: "profitSharing", name: "Reparto De Utilidades" },
    { value: "target", name: "Bono Por Avance de Metas" },
    { value: "yearEndAndPerformance", name: "Aguinaldo y Bono Anual Por Desempeño" },
    { value: "veabBonus", name: "Bono VEAB" }
  ];

  bonusName = {
    "annualPerformance": "Bono Anual Por Desempeño",
    "profitSharing": "Reparto De Utilidades",
    "target": "Bono Por Avance de Metas",
    "yearEndAndPerformance": "Aguinaldo y Bono Anual Por Desempeño",
    "veabBonus": "Bono VEAB"
  };

  // tableBonus: Array<any>;

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
    this.newRegistrationDate.indeterminate = false;

  }


  /*  createTableBonus(){
      this.tableBonus = [];
      if (this.modParameter.savingParameter.bonusPercentageForLoan && this.modParameter.savingParameter.bonusPercentageForLoan.length > 0  ){
  
         for (const iterator of this.modParameter.savingParameter.bonusPercentageForLoan) {
          let nameBonus: string = '';
          for (const type of this.bonusType) {
            if (type.value === iterator.bonus ){
              nameBonus = type.name
            }
          }
          this.tableBonus.push({nameBonus: nameBonus, startDate: iterator.period.startDate, endDate: iterator.period.endDate, indeterminate:iterator.period.indeterminate, active: iterator.period.active });
         }
      }
    }*/


  isNewDateValid(aPeriodDate: ScheduleDate): boolean {

    let valid = false;
    if (aPeriodDate.startDate) {
      if (!aPeriodDate.indeterminate) {
        if (aPeriodDate.endDate) {
          valid = true;
        }
      } else if (aPeriodDate.indeterminate) {
        if (!aPeriodDate.endDate) {
          valid = true;
        }
      }
    }

    return valid;

  }

  setRegistrationDate(type: string, event: MatDatepickerInputEvent<Moment>) {
    if (type === 'starts') {
      this.newRegistrationDate.startDate = event.value.toDate();
    } else if (type === 'ends') {
      this.newRegistrationDate.endDate = event.value.toDate();
    }
  }

  addRegistrationDate() {

    if (!this.newRegistrationDate.startDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha de inicio es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }


    if (!this.newBonusType || this.newBonusType === null) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El tipo de Aportación es requerido.',
          close: 'Aceptar'
        }
      });

      return;

    }


    if (this.isNewDateValid(this.newRegistrationDate) && this.newBonusType !== null) {

      this.newBonusInfo.bonus = this.newBonusType;
      this.newBonusInfo.period = this.newRegistrationDate;
      this.newRegistrationDate.active = true;

      this.modParameter.savingParameter.bonusPercentageForLoan.push(this.newBonusInfo);
      this.newBonusInfo = new BonusInfo({ userLeve: -1, percentage: 0, type: null });
      this.newRegistrationDate = new ScheduleDate();
      this.newRegistrationDate.startDate = null;
      this.newRegistrationDate.endDate = null;
      this.newBonusType = null;

      if (this.registrationDatesTable) {
        this.registrationDatesTable.renderRows();
      }

    } else {

      if (!this.newRegistrationDate.endDate && !this.newRegistrationDate.indeterminate) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'Las fecha de fin de inscripción es requerida si no se especifica como sin fecha fin.',
            close: 'Aceptar'
          }
        });

        return;

      }

      if (!this.newBonusType || this.newBonusType === null) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'El tipo de Aportación es requerido.',
            close: 'Aceptar'
          }
        });

        return;

      }

    }


  }

  deleteRegistrationDate(index: number) {

    this.modParameter.savingParameter.bonusPercentageForLoan.splice(index, 1);
    this.registrationDatesTable.renderRows();

  }

  selectedBonusTypeChange(event: MatSelectChange) {

    if (!event.value) {
      this.newBonusType = null;
      this.newBonusName = '';
    } else {
      this.newBonusType = event.value;
      for (const type of this.bonusType) {
        if (type.value === this.newBonusType) {
          this.newBonusName = type.name;
        }
      }
    }
  }


}
